<template>
  <div class="container qrEditItem" :class="{ 'select-color': isSelect() }">
    <div class="row justify-content-between m-0">
      <div class="col-auto item-name m-0 mb-1">
        <small>{{ itemData.itemName }}</small>
      </div>
      <div class="col-auto p-0">
        <img src="@/assets/acrypro/pencil.svg" @click="editAction" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <form onsubmit="return false;">
          <input
            type="text"
            class="w-100 px-2 text-input"
            id="text"
            placeholder="テキスト入力"
            :value="itemData.textArray[this.$store.state.currentSelectPlateNo]"
            @change="changeText"
          />
        </form>
      </div>
    </div>
    <div class="row my-2">
      <div class="col-12 d-frex">
        <div class="w-100 d-flex flex-row justify-content-between">
          <span class="color-info-text">ドットカラー</span>
          <div class="d-flex ">
            <form onsubmit="return false;" class="mx-0 px-0">
              <input
                class="colorPicker mx-0 px-0"
                style="width: 40px; height: 40px"
                type="color"
                v-model="itemData.color"
              />
            </form>
            <form onsubmit="return false;" style="display: inline-block" class="mx-0 px-0">
              <input
                type="text"
                class="text-input mx-0"
                id="text"
                placeholder="text"
                v-model="color"
                style="width: 85px"
                @change="changeColor"
              />
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row my-2">
      <div class="col-12 d-frex">
        <div class="w-100 d-flex flex-row justify-content-between">
          <span class="color-info-text">背景カラー</span>
          <div class="d-flex">
            <form onsubmit="return false;" class="mx-0 px-0">
              <input
                class="colorPicker mx-0 px-0"
                style="width: 40px; height: 40px"
                type="color"
                v-model="itemData.bgColor"
              />
            </form>
            <form onsubmit="return false;" style="display: inline-block" class="mx-0 px-0">
              <input
                type="text"
                class="text-input mx-0"
                id="text"
                placeholder="text"
                v-model="bgColor"
                style="width: 85px"
                @change="changeBgColor"
              />
            </form>

          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row my-2">
      <div class="col" @click="zoomOn" style="cursor: pointer;">
        <i class="bi bi-zoom-in"></i>
      </div>
      <div class="col" @click="zoomOff" style="cursor: pointer;">
        <i class="bi bi-zoom-out"></i>
      </div>
      <div class="col" @click="clockRotation" style="cursor: pointer;">
        <i class="bi bi-arrow-counterclockwise"></i>
      </div>
      <div class="col" @click="counterClockRotation" style="cursor: pointer;">
        <i class="bi bi-arrow-clockwise"></i>
      </div>
      <div class="col" @click="itemDelete" style="cursor: pointer;">
        <i class="bi bi-trash3 text-danger"></i>
      </div>
    </div> -->

    <div class="row mt-2">
      <div class="col-12 d-flex justify-content-between">
        <div class="icon-border cursor-pointer" @click="clockRotation">
          <img src="@/assets/acrypro/left-rotate-icon.svg"  class="d-block" style="margin: 3px;">
        </div>
        <div class="icon-border cursor-pointer" @click="counterClockRotation">
          <img src="@/assets/acrypro/right-rotate-icon.svg">
        </div>
        <div class="icon-border cursor-pointer" @click="zoomOff">
          <img src="@/assets/acrypro/zoom_in.svg" class="d-block" style="margin: 9px;">
        </div>
        <div class="icon-border cursor-pointer" @click="zoomOn">
          <img src="@/assets/acrypro/zoom_out.svg" class="d-block" style="margin: 9px;">
        </div>
        <div class="">
          <img src="@/assets/acrypro/trash-icon.svg" @click="itemDelete" class="cursor-pointer" style="width:30px;height:30px;margin-top:3px;">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { EditConfig } from "@/js/Const.js";

export default {
  name: "QREditItem",
  props: ["itemData"],
  data: function () {
    return {
      color: "",
      bgColor: "",
    };
  },
  created() {
    this.color = this.itemData.color.replace("#", "");
    this.bgColor = this.itemData.bgColor.replace("#", "");
    this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
  },
  watch: {
    "itemData.textArray": function () {
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    "itemData.color": function () {
      this.color = this.itemData.color.replace("#", "");
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    "itemData.bgColor": function () {
      this.bgColor = this.itemData.bgColor.replace("#", "");
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
  },
  methods: {
    isSelect() {
      if (!this.$store.state.currentCanvasData) {
        return false;
      }
      return this.$store.state.currentCanvasData.currentItem == this.itemData;
    },
    changeText(e) {
      let index = this.$store.state.currentCanvasData.itemList.findIndex( (element) => element.itemName == this.itemData.itemName );
      Vue.set(this.$store.state.currentCanvasData.itemList[index].textArray, this.$store.state.currentSelectPlateNo, e.target.value);
      //this.$store.state.currentCanvasData.itemList[index].textArray[this.$store.state.currentSelectPlateNo] = e.target.value;
      // this.itemData.textArray[this.$store.state.currentSelectPlateNo] = e.target.value;
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    changeColor() {
      // 正規表現で文字コードをチェック
      var regex = new RegExp(/[a-fA-F0-9]{6}/);
      if (regex.test(this.color)) {
        this.itemData.color = "#" + this.color;
      }
    },
    changeBgColor() {
      // 正規表現で文字コードをチェック
      var regex = new RegExp(/[a-fA-F0-9]{6}/);
      if (regex.test(this.bgColor)) {
        this.itemData.bgColor = "#" + this.bgColor;
      }
    },
    // 拡大
    zoomOn() {
      if (this.itemData.scale > EditConfig.MaxScale) {
        return;
      }
      this.itemData.scale += 0.1;
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    // 縮小
    zoomOff() {
      if (this.itemData.scale < EditConfig.MinScale) {
        return;
      }
      this.itemData.scale -= 0.1;
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    // 右回り
    clockRotation() {
      this.itemData.rotate -= 5;
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    // 左回り
    counterClockRotation() {
      this.itemData.rotate += 5;
      this.itemData.updateImage(this.$store.state.currentSelectPlateNo);
    },
    itemDelete(){
      if (!this.$store.state.currentCanvasData) {
        return false;
      }
      this.$store.state.currentCanvasData.itemList = 
      this.$store.state.currentCanvasData.itemList.filter(element => 
      {
        return element.itemName != this.itemData.itemName;
      });
    },
    editAction() {
      this.$store.commit("showInputText", {
        title: "名前を入力",
        value:this.itemData.itemName,
        callback:this.textInputed
      });
    },
    textInputed(inputText) {
      console.log(inputText);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.qrEditItem {
  padding: 8px;
  border-bottom: 1px solid $border-sub-color;
  background-color: $background-gray-color;
}

.select-color {
  background-color: #e6e5eb;
}

.item-name{
  color: $text-main-color;
  font-weight: bold;
  padding: 0px;
}

.text-input {
  height: 40px;
  border: 1px solid $border-sub-color;
}

.color-info-text{
  font-size: 15px;
  margin: auto 14px;
}

.fontList {
  background-color: rgb(255, 255, 255);
  max-height: 200px;
  border: 2px solid rgb(207, 226, 253);
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  /* height: 765px; */
  overflow-y: scroll;
}
.fontListItem {
  list-style-type: none;
}
.colorPicker {
  width: 20px;
  height: 20px;
  border: none;
  background: none;
}

.item-name-aria {
  width: 140px;
}

.item-name {
  font-size: 15px;
  text-align: left;
  margin-left: 10px;
  margin-top: 10px;
}

.color-edit-aria {
  width: 100px;
  font-size: 14px;
  margin-top: 10px;
}

.color-text-form {
  width: 70px;
  height: 18px;
  line-height: 18px;
}

.text-edit-btn {
  width: 23px;
  height: 23px;
}

.icon-border {
  width:40px;
  height:40px;
  background: white;
  border: 1px solid $border-sub-color;
}
</style>
